import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function ScrollDown({ delay = 0 }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is past 120px
      if (window.scrollY > 10) {
        setVisible(false); // Hide if scroll position is past the threshold
      }
    };

    // Attach the event listener on mount
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 70,
        damping: 20,
        delay,
      }}
      className="fixed w-full bottom-4 mx-auto"
    >
      <motion.div
        className="flex flex-col items-center text-white"
        animate={{
          opacity: visible ? 1 : 0, // Fade out if not visible
          y: visible ? [0, -10, 0] : 0, // Continue small up and down animation while visible
        }}
        transition={{
          opacity: { duration: 0.5 }, // Smooth fade transition duration
          y: { duration: 2, repeat: Infinity, ease: "easeInOut" }, // Keep the floating effect
        }}
      >
        <p className="text-me nsans-7-li">Scroll Down</p>
        <div className="flex flex-row items-center">
          <motion.div
            className="text-lg"
            animate={{
              y: [0, 5, 0], // Animate the arrow up and down
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            ↓
          </motion.div>
          <motion.div
            className="text-lg"
            animate={{
              y: [0, 5, 0], // Animate the arrow up and down
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.1, // Slight delay for staggered effect
            }}
          >
            ↓
          </motion.div>
          <motion.div
            className="text-lg"
            animate={{
              y: [0, 5, 0], // Animate the arrow up and down
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.2, // Slight delay for staggered effect
            }}
          >
            ↓
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
}
